import HomePage from "./Home";

export default HomePage;
